var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.bizId)?_c('QS-h3-title',{attrs:{"title":"维保方案详情","has-bottom-line":""}}):_vm._e(),_vm._v(" "),_c('basicInformation',{attrs:{"list":_vm.list,"source":_vm.source}}),_vm._v(" "),_c('comboProduct',{attrs:{"packageList":_vm.packageList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }